import { BaseModel } from './base';

export class CustomRole extends BaseModel {
  name!: string;

  override objectID(): string | null {
    return this.name ?? null;
  }
}
